import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import OButton from '../FormControls/OButton';
import { icons } from '../../../../shared/icons';
import { colors } from '../../../../shared/colors';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

/**
 * MUI Dialog
 *
 * - `maxWidth` obavezan parametar koji predstavlja maksimalnu širinu dialoga,
 * u propTypes je definisano koje vrednosti je moguće poslati
 *
 * - `open` boolean koji oznacava da li je dialog prikazan ili ne, obavezan prop
 *
 * - `handleClose` funkcija za zatvaranje dijaloga takodje obavezna
 *
 * - `title` - naslov u dialogu, opciono
 *
 * - `text` - contetnt text opcioni parametar salje se u koliko nam treba opisni dialog,
 * u koliko hocemo samo da prikazemo neki message
 *
 * - `content` - HTML element, div, paragraf, React Component, opciono
 *
 * - `handleConfirm`  - funkcija za potvrdu, takodje opciona, u koliko se ne posalje renderovace
 * se samo cancel dugme
 *
 * - `loading` - boolean parametar salje se buttonima za loader dok se api poziva
 */

const MuiDialog = ({
  maxWidth,
  open,
  handleClose,
  title,
  text,
  content,
  handleConfirm,
  loading,
  deniedText = 'Close',
  maxHeight = '',
  textConfirm = 'Acceopt',
  handlePregled,
  fullScreen,
}) => {
  const { t, i18n } = useTranslation(); // Premesti ovde unutar funkcionalne komponente

  const textConfirmTranslate = t('buttons.accept');
  const textdeniedTextTranslate = t('buttons.close');

  return (
    <Dialog
      fullScreen={fullScreen}
      fullWidth
      maxWidth={maxWidth}
      open={open}
      onClose={handleClose}
      PaperProps={{
        style: {
          height: maxHeight,
        },
      }}
    >
      {title && <DialogTitle>{title}</DialogTitle>}
      <DialogContent>
        {text && <DialogContentText>{text}</DialogContentText>}
        {content}
      </DialogContent>
      <DialogActions>
        {handlePregled && (
          <OButton
            text="PREGLED"
            startIcon={icons.PREVIEW_ICON}
            style={{
              color: colors.DIALOG_PRIMARY,
              backgroundColor: colors.WHITE,
              border: `1px solid ${colors.DIALOG_PRIMARY}`,
            }}
            onClick={handlePregled}
            isLoading={loading}
            disabled={loading}
          />
        )}
        <OButton
          text={textdeniedTextTranslate}
          startIcon={icons.DIALOG_CLOSE}
          style={{
            color: colors.ORANGE,
            backgroundColor: colors.WHITE,
            border: `1px solid ${colors.ORANGE}`,
          }}
          onClick={handleClose}
        />
        {handleConfirm && (
          <OButton
            text={textConfirmTranslate}
            startIcon={icons.DIALOG_CHECK}
            onClick={handleConfirm}
            isLoading={loading}
            disabled={loading}
            style={{
              color: colors.WHITE,
              backgroundColor: colors.ORANGE,
              border: `1px solid ${colors.ORANGE}`,
            }}
          />
        )}
      </DialogActions>
    </Dialog>
  );
};

export default MuiDialog;

MuiDialog.propTypes = {
  maxWidth: PropTypes.oneOf([false, 'xs', 'sm', 'md', 'lg', 'xl']).isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  text: PropTypes.string,
  content: PropTypes.element,
  handleConfirm: PropTypes.func,
  handlePregled: PropTypes.func,
};
